// external imports
import React from 'react'
import { QueryRenderer } from 'react-relay'
// local imports
import environment from '~/relayEnv'

export default ({ render, ...props }) => (
    <QueryRenderer
        {...props}
        environment={environment}
        render={({ error, props: result, ...rest }) => {
            // if there is an error
            if (error) {
                throw new Error(error)
            }
            // call the render callback
            return render(result)
        }}
    />
)



// WEBPACK FOOTER //
// ./src/components/QueryRenderer.js